import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Attach the admin auth token to every API request.
const _originalFetch = window.fetch;
window.fetch = function (url, options = {}) {
  const token = localStorage.getItem('user-token');
  if (token && typeof url === 'string' && url.includes('/api/')) {
    options.headers = Object.assign({}, options.headers, {
      Authorization: 'Bearer ' + token,
    });
  }
  return _originalFetch(url, options);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      {/* <BrowserRouter>   */}
          <App />
      {/* </BrowserRouter> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
